/** Constant client IDs. */
export enum KnownClientId {
  /** Client used as a template for new designs. */
  archType = '00490804-0ad8-4bb1-8925-0ca99d97914f',
  /** Client with all the common modules. */
  interactionsCommon = '7ff11910-0bd1-43f7-b542-02890e4196cc'
}
